module.exports = __webpack_public_path__ + "down_active.png?0beb3916c598da41bbe37c17e376e457";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/down_active.png
// module id = 959
// module chunks = 2